const WRAPPER_LAPP_URLS = {
  DEVAI_URL: "https://20.204.99.128/devai",
};

export { WRAPPER_LAPP_URLS };
